<div fxLayout="row">
	<h3 style="font-weight: 100">
		Please tell us about your interaction to help us give you better results.
	</h3>
</div>
<div fxLayout="row">
	<div fxFlex fxLayoutAlign="start start">Did you reach the carrier?</div>
	<div fxFlex="19" fxLayoutAlign="space-around center">
		<span
			(click)="feedbackNotGiven && updateAnswer('reached_carrier', false)"
			[ngClass]="
				!utilService.isNullOrUndefined(feedbackQuestionMap.reached_carrier.answer) &&
				getActionButtonClass('reached_carrier', false)
			"
			class="primary-text cursor-pointer"
		>
			No
		</span>
		<span
			(click)="feedbackNotGiven && updateAnswer('reached_carrier', true)"
			[ngClass]="
				!utilService.isNullOrUndefined(feedbackQuestionMap.reached_carrier.answer) &&
				getActionButtonClass('reached_carrier', true)
			"
			class="primary-text cursor-pointer"
			color="primary"
		>
			Yes
		</span>
	</div>
</div>

<!-- <div fxLayout="row" style="margin-top: 0.5rem">
	<div fxFlex fxLayoutAlign="start start">Who did you talk to?</div>
	<div fxFlex=18 fxLayoutAlign="space-around center">
		<mat-form-field>
			<mat-select placeholder="Contact name" [(value)]="feedbackQuestionMap['contact_id']['answer']"
				[disabled]="!isReachedCarrierAnswered() || !this.feedbackQuestionMap.reached_carrier.answer">
				<mat-option (click)="openContactDialog(null)">Add Contact</mat-option>
				<mat-option (click)="editContact()">Edit Contact</mat-option>
				<mat-option *ngFor="let contact of contactList" [value]="contact.contactId">
					{{contact.firstName}}
				</mat-option>
			</mat-select>
		</mat-form-field>
	</div>
</div> -->

<!-- <div *ngIf="showQuestion('booked_load')" style="margin-top: 0.5rem">
	<div fxFlex fxLayoutAlign="start start">Did you book a load?</div>
	<div fxFlex=19 fxLayoutAlign="space-around center">
		<button mat-raised-button (click)="feedbackNotGiven && updateAnswer('booked_load', false)"
			[ngClass]="!utilService.isNullOrUndefined(feedbackQuestionMap.booked_load.answer) && getActionButtonClass('booked_load', false)"
		>
			No
		</button>
		<button mat-raised-button color="primary" (click)="feedbackNotGiven && updateAnswer('booked_load', true);"
			[ngClass]="!utilService.isNullOrUndefined(feedbackQuestionMap.booked_load.answer) && getActionButtonClass('booked_load', true)"
		>
			Yes
		</button>
	</div>
</div> -->

<div>
	<div class="m-t-1" fxLayout="row">
		<div fxFlex fxLayoutAlign="start center">How was the conversation?</div>
		<div fxFlex="19" fxLayoutAlign="end center">
			<ng-rating-bar
				(valueChange)="allQuestionsAnswered()"
				[(value)]="feedbackQuestionMap['rating']['answer']"
				[disabled]="!isReachedCarrierAnswered() || !feedbackQuestionMap.reached_carrier.answer"
				[ratingCount]="5"
			>
			</ng-rating-bar>
		</div>
	</div>

	<div class="m-t-1" fxLayout="row">
		<div fxFlex fxLayoutAlign="start center">Did they have capacity?</div>
		<div fxFlex="19" fxLayoutAlign="space-around center">
			<span
				(click)="
					!isReachedCarrierAnswered() || !feedbackQuestionMap.reached_carrier.answer
						? null
						: feedbackNotGiven && updateAnswer('hasCapacity', false)
				"
				[ngClass]="
					!utilService.isNullOrUndefined(feedbackQuestionMap.hasCapacity.answer) &&
					getActionButtonClass('hasCapacity', false)
				"
				class="primary-text cursor-pointer"
			>
				No
			</span>
			<span
				(click)="
					!isReachedCarrierAnswered() || !feedbackQuestionMap.reached_carrier.answer
						? null
						: feedbackNotGiven && updateAnswer('hasCapacity', true)
				"
				[ngClass]="
					!utilService.isNullOrUndefined(feedbackQuestionMap.hasCapacity.answer) &&
					getActionButtonClass('hasCapacity', true)
				"
				class="primary-text cursor-pointer"
				color="primary"
			>
				Yes
			</span>
		</div>
	</div>

	<div class="m-t-1" fxLayout="row">
		<div fxFlex fxLayoutAlign="start center">What would make the conversation better?</div>
		<div fxFlex="19" fxLayoutAlign="end center">
			<div
				(click)="
					!isReachedCarrierAnswered() || !feedbackQuestionMap.reached_carrier.answer
						? null
						: openFeedbackDialog()
				"
				class="font-size-14 padding-0-5 cursor-pointer input-box feedback-input-width ellipsis"
				fxFlex
			>
				{{
					IS_NOT_EMPTY(feedbackQuestionMap.userSuggestion.answer)
						? feedbackQuestionMap.userSuggestion.answer
						: 'Start typing'
				}}
			</div>
		</div>
	</div>
</div>

<!-- <div *ngIf="showQuestion('load_not_booked_reason')" style="margin-top: 0.5rem">
	<div fxFlex fxLayoutAlign="start start">Why Not</div>
	<div fxFlex=18 fxLayoutAlign="space-around center">
		<mat-form-field>
			<mat-select placeholder="Select" [(value)]="feedbackQuestionMap['load_not_booked_reason']['answer']"
					(selectionChange)="allQuestionsAnswered()" [disabled]="!feedbackNotGiven">
				<mat-option *ngFor="let reason of loadNotBookedReasons" [value]="reason">{{reason}}</mat-option>
			</mat-select>
		</mat-form-field>
	</div>
</div> -->
